import { Component, TemplateRef, contentChild, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-select',
  templateUrl: './primeng-select.component.html',
  styleUrls: ['./primeng-select.component.scss'],
  standalone: false,
})
export class PrimengSelectComponent {
  options = input<any[]>([]);
  optionLabel = input<string>('label');
  optionValue = input<string>('value');
  placeholder = input<string>('Select an option');
  value = model<any>(null);
  disabled = input<boolean>(false);
  filter = input<boolean>(false);
  showClear = input<boolean>(false);
  appendTo = input<string>('body');
  styleClass = input<string>('');
  /** Id of the inner input, so a <label for="…"> can point at it. */
  inputId = input<string>('');
  panelStyleClass = input<string>('');
  emptyMessage = input<string>('No results found');
  loading = input<boolean>(false);
  size = input<'large' | 'small' | undefined>('small');

  onChange = output<any>();
  onClear = output<void>();

  /** Custom item template: <ng-template #selectItem let-item>...</ng-template> */
  itemTemplate = contentChild<TemplateRef<any>>('selectItem');
  /** Custom selected item template */
  selectedItemTemplate = contentChild<TemplateRef<any>>('selectSelected');

  handleChange(event: any) {
    // event.value is the new selected scalar (respects optionValue) from PrimeNG's onChange.
    // If the bound optionValue key is missing, PrimeNG hands back the whole option
    // object; unwrap it so page filter state only ever holds primitives.
    this.value.set(PrimengSelectComponent.unwrapOption(event.value));
    this.onChange.emit(event);
  }

  handleClear() {
    this.value.set(null);
    this.onClear.emit();
  }

  /** Returns optionValue / label / value for object options, otherwise the value as-is. */
  private static unwrapOption(value: any): any {
    if (!value || typeof value !== 'object' || Array.isArray(value) || value instanceof Date) {
      return value ?? null;
    }
    const key = 'value';
    return value[key] ?? value['label'] ?? value['name'] ?? value;
  }
}
